import Section from '../components/section/Section';
import Cards from '../components/cards/Cards';

export default function Services() {
    const services1 = [
        {
            title: "EMB test inclusief afname $199,-",
            text: "Een EMB test bestaat uit een intakegesprek van 45 minuten inclusief afname. Na 4 weken ontvang je via de mail de uitslag met een voeding en supplementenadvies per mail. Een vervolgconsult moet apart geboekt worden."
        },
        {
            title: "Voedingsadvies $225,-",
            text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                    Praesent sit amet massa ut nibh tincidunt condimentum tincidunt vel sapien. 
                    Nullam finibus imperdiet finibus. Cras sit amet risus lorem. 
                    Maecenas sed nisl non mauris sagittis facilisis id at nulla. 
                    Aliquam eget efficitur mauris, sed sollicitudin sem.
                    Maecenas luctus magna sit amet odio accumsan, a vulputate erat semper. 
                    Donec dictum orci odio, eget lacinia lorem molestie et. Duis eleifend vel enim vel auctor. 
                    Phasellus semper justo nec ante ultrices, nec congue tellus commodo. 
                    Sed iaculis aliquam scelerisque. Integer ut urna elit.`
        }
    ];
    
    const services2 = [
        {
            title: "EMB consult traject $295,-",
            text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                    Praesent sit amet massa ut nibh tincidunt condimentum tincidunt vel sapien. 
                    Nullam finibus imperdiet finibus. Cras sit amet risus lorem. 
                    Maecenas sed nisl non mauris sagittis facilisis id at nulla. 
                    Aliquam eget efficitur mauris, sed sollicitudin sem.
                        Maecenas luctus magna sit amet odio accumsan, a vulputate erat semper. 
                        Donec dictum orci odio, eget lacinia lorem molestie et. Duis eleifend vel enim vel auctor. 
                        Phasellus semper justo nec ante ultrices, nec congue tellus commodo. 
                        Sed iaculis aliquam scelerisque. Integer ut urna elit.`
        },
        {
            title: "Coaching traject $375,-",
            text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                    Praesent sit amet massa ut nibh tincidunt condimentum tincidunt vel sapien. 
                    Nullam finibus imperdiet finibus. Cras sit amet risus lorem. 
                    Maecenas sed nisl non mauris sagittis facilisis id at nulla. Aliquam eget efficitur mauris, 
                    sed sollicitudin sem. Maecenas luctus magna sit amet odio accumsan, a vulputate erat semper.`
        }
    ]
    return (
      <>
        <div className="content">
           <Section>
                <div className="col-xs-12">
                    <div className="box">
                        <h1 className="margin-bottom-20">Aanbod</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Etiam pretium posuere sem eget rutrum. 
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
                            Quisque nibh enim, malesuada sed elementum sed, sollicitudin dapibus mi. 
                            Sed fringilla sapien tortor, in sollicitudin nulla vulputate eu. 
                            Aliquam quis faucibus elit, sed commodo velit. Ut in odio a arcu fermentum faucibus. 
                            Nam ut libero ultricies, pulvinar libero eget, commodo neque.</p>
                    </div>
                </div>
            </Section>
            <Section color={"green"}>
                    <div className="col-xs-12">
                        <Cards cards={services1}></Cards>
                        <Cards cards={services2}></Cards>
                    </div>
            </Section>
        </div>
      </>
    );
  }